import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import '../styles/TestimonialsSection.css';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Krim Mezouari',
      role: 'Etudes Canada',
      text: 'Très sérieux',
      rating: 5
    },
    {
      id: 2,
      name: 'Anouar Sassi',
      role: 'Tourisme France',
      text: 'Top service!',
      rating: 5
    },
    {
      id: 3,
      name: 'Slimani Messaoude',
      role: 'Campus France',
      text: 'Rebi ibarek trop accueillant, excellente équipe',
      rating: 5
    },
      {
        id: 4,
        name: 'Anouar Benomar',
        role: 'Résidence Qatar',
        text: 'Pro in every way Very welcoming team and very helpfull',
        rating: 5
      },
      {
        id: 5,
        name: 'Selmane Osmani',
        role: 'Tourisme Canada',
        text: "J'etais avec un ami pour tourisme rebi barek Yanis les.hommes w professionnel khadma je tire chapeau",
        rating: 5
      },
      {
        id: 6,
        name: 'Ilyes Berbache',
        role: 'Immigration Canada',
        text: "Machallah bon travail c'est ya de ouverture arrima ou bien  entré experess annoncé",
        rating: 5
      }, 
      {
        id: 7,
        name: 'Amine Baziz',
        role: 'Etudes Roumanie',
        text: "Un petit compliment , Juste par rapport a la qualité et le service fournis par l'ensemble de l'équipe , Thank You so Much Guys All the Best",
        rating: 5
      }
  ];
  
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1); // 1 for right, -1 for left
  
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    
    return () => clearInterval(interval);
  }, [current]);
  
  const nextSlide = () => {
    setDirection(1);
    setCurrent(current === testimonials.length - 1 ? 0 : current + 1);
  };
  
  const prevSlide = () => {
    setDirection(-1);
    setCurrent(current === 0 ? testimonials.length - 1 : current - 1);
  };
  
  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      x: direction > 0 ? -1000 : 1000,
      opacity: 0
    })
  };
  
  return (
    <section id="testimonials" className="section testimonials-section">
      <div className="container">
        <h2 className="section-title">Témoignage de nos clients sur Google Maps</h2>
        
        <div className="testimonials-slider">
          <AnimatePresence initial={false} custom={direction} mode="wait">
            <motion.div
              key={current}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ type: 'tween', duration: 0.5 }}
              className="testimonial"
            >
              <div className="quote-icon">
                <FaQuoteLeft />
              </div>
              <p className="testimonial-text">{testimonials[current].text}</p>
              <div className="rating">
                {[...Array(5)].map((_, i) => (
                  <FaStar 
                    key={i} 
                    className={i < testimonials[current].rating ? 'star active' : 'star'} 
                  />
                ))}
              </div>
              <div className="testimonial-author">
                <h4>{testimonials[current].name}</h4>
                <p>{testimonials[current].role}</p>
              </div>
            </motion.div>
          </AnimatePresence>
          
          <div className="slider-controls">
            <button className="control-btn prev" onClick={prevSlide}>
              &lt;
            </button>
            <div className="dots">
              {testimonials.map((_, index) => (
                <span 
                  key={index} 
                  className={`dot ${index === current ? 'active' : ''}`}
                  onClick={() => {
                    setDirection(index > current ? 1 : -1);
                    setCurrent(index);
                  }}
                ></span>
              ))}
            </div>
            <button className="control-btn next" onClick={nextSlide}>
              &gt;
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection; 